<div
  class="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md transition-all duration-300 shadow-sm border-b border-gray-200"
  [ngClass]="{ 'shadow-md border-gray-300': isScrolled }"
>
  <div class="px-6">
    <!-- Clean Header Layout -->
    <div
      class="flex flex-col md:flex-row md:items-center md:justify-between min-h-10 md:min-h-10 py-0 md:py-0"
    >
      <!-- Top Row on Mobile / Single Row on Desktop -->
      <div
        class="flex items-center justify-between md:justify-start md:space-x-6 min-h-8 md:min-h-10"
      >
        <!-- Clean Logo -->
        <div class="flex items-center flex-shrink-0">
          <a
            [routerLink]="['/sites']"
            class="cursor-pointer group flex items-center"
          >
            <img
              src="assets/login/qpilot-logo-blue-600.png"
              alt="QPilot"
              class="h-6 w-auto group-hover:opacity-80 transition-opacity duration-300"
            />
          </a>
        </div>
        <!-- Mobile: Visit Store Button and Menu Button (visible on small screens) -->
        <div
          *ngIf="sessionService.user"
          class="md:hidden flex items-center gap-2 flex-shrink-0"
        >
          <!-- Visit Store Button -->
          <app-visit-store-button
            [shouldShowButton]="shouldShowVisitStoreButton"
            [siteUrl]="siteUrl"
          />
          <!-- Mobile Menu Button -->
          <p-menu
            #mobileMenu
            [model]="mobileMenuItems"
            [popup]="true"
            appendTo="body"
            styleClass="mobile-nav-menu"
          />
          <button
            class="p-1.5 rounded-xl hover:bg-gradient-to-r hover:from-slate-100 hover:to-slate-50 transition-all duration-300 border border-transparent hover:border-slate-200/50 hover:shadow-sm"
            pTooltip="Menu"
            tooltipPosition="bottom"
            (click)="mobileMenu.toggle($event)"
          >
            <i class="pi pi-bars text-slate-700 text-xs"></i>
          </button>
        </div>
      </div>

      <!-- Desktop Navigation and User Menu -->
      <div class="hidden md:flex md:items-center md:space-x-6">
        <!-- Clean Navigation -->
        <div class="flex items-center space-x-1">
          <ng-container *ngFor="let item of items">
            <!-- Internal routes -->
            <a
              *ngIf="item.routerLink && !item.url"
              [routerLink]="item.routerLink"
              class="group p-2 rounded-lg hover:bg-gray-100 transition-all duration-200 flex items-center justify-center"
              pTooltip="{{ item.label }}"
              tooltipPosition="bottom"
              routerLinkActive="bg-blue-100 text-blue-700"
            >
              <i
                class="{{
                  item.icon
                }} text-gray-600 group-hover:text-blue-700 text-lg transition-colors duration-200"
              ></i>
            </a>
            <!-- External URLs -->
            <a
              *ngIf="item.url"
              [href]="item.url"
              class="group p-2 rounded-lg hover:bg-gray-100 transition-all duration-200 flex items-center justify-center"
              pTooltip="{{ item.label }}"
              tooltipPosition="bottom"
            >
              <i
                class="{{
                  item.icon
                }} text-gray-600 group-hover:text-blue-700 text-lg transition-colors duration-200"
              ></i>
            </a>
          </ng-container>
        </div>

        <!-- Clean User Section -->
        <div
          *ngIf="sessionService.user"
          class="flex items-center gap-3 flex-shrink-0"
        >
          <!-- Visit Store Button -->
          <app-visit-store-button
            [shouldShowButton]="shouldShowVisitStoreButton"
            [siteUrl]="siteUrl"
          />
          <p-menu
            #userMenu
            [model]="userMenuItems"
            [popup]="true"
            appendTo="body"
            styleClass="modern-user-menu"
          />

          <!-- User Profile Section -->
          <div class="group">
            <!-- User Card - Clickable to open menu -->
            <div
              class="flex items-center bg-white hover:bg-gray-50 px-2 py-1 rounded-lg border border-gray-200 hover:border-gray-300 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md"
              (click)="userMenu.toggle($event)"
              pTooltip="Account Menu"
              tooltipPosition="bottom"
            >
              <!-- User Avatar -->
              <div class="relative mr-2">
                <div
                  class="w-6 h-6 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold text-xs shadow-sm"
                >
                  {{ sessionService.user.Email | slice: 0 : 1 | uppercase }}
                </div>
              </div>

              <!-- User Info -->
              <div class="flex flex-col mr-2">
                <span
                  class="text-xs font-medium text-gray-800 truncate max-w-32 lg:max-w-48"
                  [title]="sessionService.user.Email"
                >
                  {{
                    sessionService.user.Email
                      | slice: 0 : sessionService.user.Email.indexOf("@")
                  }}
                </span>
              </div>

              <!-- Menu Indicator -->
              <i class="pi pi-chevron-down text-gray-400 text-xs ml-auto"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Spacer to prevent content from being hidden under fixed header -->
<div class="h-10 md:h-10"></div>
